import { LegalLayout } from '../components/LegalLayout';

export default function AGB() {
  return (
    <LegalLayout title="Allgemeine Geschäftsbedingungen">
      <p className="text-sm text-slate-500">
        Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB") regeln das Vertragsverhältnis
        zwischen dem Anbieter und dem Nutzer für die Nutzung der Software-as-a-Service-Anwendung
        Kivera.
      </p>

      <h2>§ 1 Geltungsbereich</h2>
      <p>
        (1) Diese AGB gelten für sämtliche Verträge zwischen <strong>SideQuestGuy.com</strong>{' '}
        (Inhaber: Arno Strehle, Stresemannplatz 2, 01309 Dresden – nachfolgend „Anbieter") und dem
        Kunden (nachfolgend „Nutzer") über die Nutzung der Anwendung „Kivera".
        <br />
        (2) Abweichende oder ergänzende Bedingungen des Nutzers werden nicht Vertragsbestandteil,
        sofern der Anbieter ihrer Geltung nicht ausdrücklich schriftlich zustimmt.
      </p>

      <h2>§ 2 Vertragsgegenstand</h2>
      <p>
        (1) Der Anbieter stellt dem Nutzer Kivera als browserbasierte Software-as-a-Service-Lösung
        zur Verwaltung von Immobilien und zur Erstellung von Nebenkostenabrechnungen zur Verfügung.
        <br />
        (2) Der konkrete Funktionsumfang ergibt sich aus der jeweils gewählten Tarifoption und der
        Beschreibung auf der Website kivera.de.
        <br />
        (3) Der Anbieter ist berechtigt, den Funktionsumfang weiterzuentwickeln und anzupassen,
        soweit der wesentliche Leistungsumfang nicht beeinträchtigt wird.
      </p>

      <h2>§ 3 Registrierung und Nutzerkonto</h2>
      <p>
        (1) Die Nutzung von Kivera setzt eine Registrierung und einen gültigen Einladungscode voraus.
        <br />
        (2) Der Nutzer ist verpflichtet, bei der Registrierung wahrheitsgemäße und vollständige
        Angaben zu machen und diese stets aktuell zu halten.
        <br />
        (3) Zugangsdaten sind vertraulich zu behandeln. Der Nutzer haftet für jede Nutzung seines
        Kontos durch Dritte, sofern er diese zu vertreten hat.
      </p>

      <h2>§ 4 Pflichten des Nutzers</h2>
      <p>(1) Der Nutzer verpflichtet sich, Kivera ausschließlich im Rahmen der geltenden Gesetze zu nutzen. Insbesondere ist es untersagt:</p>
      <ul>
        <li>rechtswidrige, beleidigende oder diskriminierende Inhalte einzustellen,</li>
        <li>Sicherheitsmechanismen der Anwendung zu umgehen,</li>
        <li>Schadsoftware oder Skripte zur automatisierten Massenabfrage einzusetzen,</li>
        <li>fremde personenbezogene Daten ohne Rechtsgrundlage zu verarbeiten.</li>
      </ul>
      <p>
        (2) Der Nutzer ist als verantwortliche Stelle im Sinne der DSGVO für die von ihm
        gespeicherten Daten seiner Mieter und Geschäftspartner selbst verantwortlich.
      </p>

      <h2>§ 5 Preise und Zahlungsbedingungen</h2>
      <p>
        (1) Die Nutzungs­entgelte richten sich nach der bei Vertragsschluss gültigen Preisliste auf
        kivera.de. Alle Preise verstehen sich – sofern nicht anders ausgewiesen – inklusive der
        gesetzlichen Umsatzsteuer.
        <br />
        (2) Die Zahlung erfolgt im Voraus für den jeweils gewählten Abrechnungszeitraum (monatlich
        oder jährlich).
        <br />
        (3) Der Anbieter behält sich vor, die Preise mit angemessener Vorankündigung (mindestens
        30 Tage) anzupassen. Bei Preiserhöhungen steht dem Nutzer ein Sonderkündigungsrecht zum
        Wirksamwerden der Preiserhöhung zu.
      </p>

      <h2>§ 6 Verfügbarkeit und Wartung</h2>
      <p>
        (1) Der Anbieter ist um eine Verfügbarkeit von 99 % im Jahresmittel bemüht. Geplante
        Wartungs­fenster werden – soweit möglich – angekündigt.
        <br />
        (2) Außerhalb der Einflusssphäre des Anbieters liegende Beeinträchtigungen
        (z. B. Netzausfälle Dritter, höhere Gewalt) bleiben außer Betracht.
      </p>

      <h2>§ 7 Datenschutz und Auftragsverarbeitung</h2>
      <p>
        (1) Soweit der Anbieter im Auftrag des Nutzers personen­bezogene Daten verarbeitet,
        schließen die Parteien auf Anforderung des Nutzers einen Vertrag zur Auftragsverarbeitung
        gemäß Art. 28 DSGVO ab.
        <br />
        (2) Weitere Informationen zum Umgang mit Daten finden sich in der{' '}
        <a href="/datenschutz">Datenschutzerklärung</a>.
      </p>

      <h2>§ 8 Gewährleistung</h2>
      <p>
        (1) Der Anbieter gewährleistet eine im Wesentlichen vertragsgemäße Beschaffenheit der
        Anwendung. Unwesentliche Abweichungen begründen keine Mängelansprüche.
        <br />
        (2) Auftretende Mängel werden in angemessener Frist nach Meldung beseitigt. Der Nutzer ist
        verpflichtet, Mängel unverzüglich zu melden.
      </p>

      <h2>§ 9 Haftung</h2>
      <p>
        (1) Der Anbieter haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit, für die
        Verletzung von Leben, Körper oder Gesundheit sowie nach den Vorschriften des
        Produkthaftungsgesetzes.
        <br />
        (2) Bei leicht fahrlässiger Verletzung wesentlicher Vertragspflichten (Kardinalpflichten)
        ist die Haftung auf den vertragstypisch vorhersehbaren Schaden begrenzt.
        <br />
        (3) Für eine Wiederherstellung von Daten haftet der Anbieter nur, wenn der Nutzer eine
        ordnungsgemäße Datensicherung durchgeführt hat.
        <br />
        (4) Eine darüber hinausgehende Haftung ist ausgeschlossen.
      </p>

      <h2>§ 10 Laufzeit und Kündigung</h2>
      <p>
        (1) Der Vertrag wird auf unbestimmte Zeit geschlossen und kann von beiden Seiten zum Ende
        des jeweils gebuchten Abrechnungszeitraums (Monat bzw. Jahr) gekündigt werden.
        <br />
        (2) Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.
        <br />
        (3) Kündigungen bedürfen der Textform (z. B. E-Mail).
        <br />
        (4) Nach Vertragsende werden die Daten des Nutzers nach Ablauf einer Schon­frist von 30
        Tagen unwider­ruflich gelöscht. Innerhalb dieser Frist kann der Nutzer einen Datenexport
        anfordern.
      </p>

      <h2>§ 11 Schlussbestimmungen</h2>
      <p>
        (1) Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
        Gegenüber Verbrauchern gilt diese Rechtswahl nur, soweit dadurch keine zwingenden
        Schutzvorschriften des Staates, in dem der Verbraucher seinen gewöhnlichen Aufenthalt hat,
        eingeschränkt werden.
        <br />
        (2) Ausschließlicher Gerichtsstand für Streitigkeiten mit Kaufleuten ist Dresden.
        <br />
        (3) Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der
        übrigen Bestimmungen unberührt.
      </p>

      <p className="text-sm text-slate-500 mt-12">
        Stand: {new Date().toLocaleDateString('de-DE', { month: 'long', year: 'numeric' })}
      </p>
    </LegalLayout>
  );
}
